import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { type IncomeProtectionStepParams, hasIncomeProtectionSchema } from './types'

export const hasIncomeProtection = (params: IncomeProtectionStepParams) =>
  ({
    schema: hasIncomeProtectionSchema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_incomeProtection:steps.has_income_protection.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('has_income_protection'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'employment_status',
    subFlow: SubFlow.IncomeProtection,
  }) as const satisfies AnyStepConfiguration
